import React, { useEffect } from 'react';
import Navbar from './Navbar';
import { cn } from '@/lib/utils';
import { useLocation, Outlet } from 'react-router-dom';
import { leagueStandings } from '@/data/teamsData';
import { formatDate, formatTime } from '@/lib/utils';
import { Toaster } from '@/components/ui/sonner';
import { toast } from 'sonner';

const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  
  // Show timestamp only on standings page
  const isStandingsPage = location.pathname === '/standings';

  
  // Find the most recent lastUpdated timestamp across all divisions
  let lastUpdatedTimestamp: string | null = null;
  if (isStandingsPage) {
    for (const division in leagueStandings) {
      const divisionData = leagueStandings[division];
      if (divisionData.length > 0 && divisionData[0].lastUpdated) {
        if (!lastUpdatedTimestamp || new Date(divisionData[0].lastUpdated) > new Date(lastUpdatedTimestamp)) {
          lastUpdatedTimestamp = divisionData[0].lastUpdated;
        }
      }
    }
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* Ensure Navbar is only rendered once */}
      <Navbar />
      <main className={cn('flex-1 px-0 py-1 md:px-2 md:py-8')}>
        <div className="container mx-auto px-4">
          {children ?? <Outlet />}
        </div>
      </main>
      
      {isStandingsPage && lastUpdatedTimestamp && (
        <div className="px-2 pt-6 pb-2 md:px-6">
          <div className="container mx-auto">
            <div className="text-sm text-muted-foreground">
              Last updated: {formatDate(lastUpdatedTimestamp)} {formatTime(lastUpdatedTimestamp)}
            </div>
          </div>
        </div>
      )}
      
      <footer className="py-6 px-2 md:px-6 border-t border-border/50">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-muted-foreground mb-4 md:mb-0">
              © {new Date().getFullYear()} Official Scoring. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
      <Toaster />
    </div>
  );
};

export default Layout;